import { Trans } from '~/common/context';
import type { IOrder } from '@wyz/types';
import { Badge, Flex, Icon, Modal, Text } from '@wyz/ui';
import clsx from 'clsx';
import { isNil } from 'lodash-es';
import { OrderHelpers } from '~/purchase/helpers';
import { TRACKING_STATUS_LABEL_LOOKUP } from '~/purchase/translators';

type PopoverProps = {
  order: IOrder;
  open: boolean;
  onClose: () => void;
};
const TrackingListModal = ({ order, open, onClose }: PopoverProps) => {
  return (
    <Modal.Container open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey='app.purchase.orders.table.tracking' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {order.trackings?.map((trackingItem, index) => (
          <Flex
            alignItems='center'
            alignContent='between'
            key={index}
            className='bg-neutral-grey-1 p-3 mb-2'
          >
            <Text
              color='tertiary'
              weight='bold'
              heading='normal'
              className='flex-grow-1'
            >
              <Trans i18nKey='app.purchase.order_detail.tracking.package' />{' '}
              {index + 1}
            </Text>
            <Flex className='space-x-4'>
              <Badge
                bg={
                  OrderHelpers.TRACKING_STATUS_COLOR_LOOKUP[
                    trackingItem.status
                  ] ?? 'secondary'
                }
                pill
              >
                <Trans
                  i18nKey={TRACKING_STATUS_LABEL_LOOKUP[trackingItem.status]}
                  defaults={trackingItem.status}
                />
              </Badge>
              <a
                href={trackingItem.url}
                className={clsx({
                  'disabled-link': isNil(trackingItem.url),
                })}
                target='_blank'
                rel='noreferrer'
              >
                <Text color='tertiary' weight='semi-bold' heading='xs'>
                  <Icon icon='map-marker' size='xs' />{' '}
                  <Trans i18nKey='app.purchase.orders.table.tracking' />
                </Text>
              </a>
            </Flex>
          </Flex>
        ))}
      </Modal.Body>
    </Modal.Container>
  );
};

export default TrackingListModal;
